import { render, staticRenderFns } from "./JournalView.vue?vue&type=template&id=f505e210"
import script from "./JournalView.vue?vue&type=script&lang=js"
export * from "./JournalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports